// Tiny hash router for company pages:  #/stock/AAPL  or  #/stock/AAPL/financials
export const TABS = [
  { key: "overview", label: "Overview & News" },
  { key: "financials", label: "Financials" },
  { key: "valuation", label: "Valuation" },
  { key: "model", label: "Model" },
  { key: "estimates", label: "Estimates" },
  { key: "transcripts", label: "Transcripts" },
  { key: "filings", label: "Filings" },
  { key: "ownership", label: "Ownership" },
];

export function parseHash(hash = window.location.hash) {
  const m = /^#\/stock\/([^/?]+)(?:\/([a-z]+))?/i.exec(hash || "");
  if (!m) return null;
  const tab = TABS.some((t) => t.key === m[2]) ? m[2] : "overview";
  return { ticker: decodeURIComponent(m[1]).toUpperCase(), tab };
}

export const stockPath = (ticker, tab) =>
  `#/stock/${encodeURIComponent(ticker)}${tab && tab !== "overview" ? `/${tab}` : ""}`;

export function goToStock(ticker, tab) {
  window.location.hash = stockPath(ticker, tab);
}

export function clearStockHash() {
  if (window.location.hash.startsWith("#/stock/")) {
    history.pushState(null, "", window.location.pathname + window.location.search);
  }
}
